import { render, staticRenderFns } from "./CompanyCount.vue?vue&type=template&id=21a8e430&scoped=true&"
import script from "./CompanyCount.vue?vue&type=script&lang=js&"
export * from "./CompanyCount.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCount.vue?vue&type=style&index=0&id=21a8e430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8e430",
  null
  
)

export default component.exports